import { serviceProvider, statusChangeRequest } from "./serviceProvider";

/**
 * all api services of login user
 */
const networkConfigServices = {
  getNetworkList,
  CreateOrUpdateNetwork,
  downloadExcelSheet,
  DeactivateNetwork,
  ReactivateNetwork,
  DeactivateMapping,
  ReactivateMapping,
};

/**
 * @description api calling function for network list
 * @param {payload request to fetch network list} reqPayload
 * @returns
 */
async function getNetworkList(reqPayload, headerData) {
  return await serviceProvider(
    "POST",
    "Network/GetNetworkList",
    reqPayload,
    headerData
  );
}

/**
 * @description api calling function to create and update network
 * @param {payload request to create and update network} reqPayload
 * @returns
 */
async function CreateOrUpdateNetwork(reqPayload, headerData) {
  return await serviceProvider(
    "POST",
    "Network/CreateOrUpdate",
    reqPayload,
    headerData
  );
}

/**
 * @description api calling function to download excel sheet
 * @param {payload request to download excel sheet} zoneId
 * @returns
 */

async function downloadExcelSheet(zoneId, headerData) {
  return serviceProvider(
    "GET",
    `Zone/Download?zoneId=${zoneId}`,
    {},
    headerData
  );
}

/**
 * @description soft-delete a network in every zone that uses it
 * @param {*id of network (not mznlId)} networkId
 * @returns
 */
async function DeactivateNetwork(networkId, headerData) {
  return await statusChangeRequest("Network/Deactivate", networkId, headerData);
}

/**
 * @description restore a deactivated network
 * @param {*id of network (not mznlId)} networkId
 * @returns
 */
async function ReactivateNetwork(networkId, headerData) {
  return await statusChangeRequest("Network/Reactivate", networkId, headerData);
}

/**
 * @description remove a network from this zone only (zone-network mapping)
 * @param {*mznlId of the network row (not network id)} mznlId
 * @returns
 */
async function DeactivateMapping(mznlId, headerData) {
  return await statusChangeRequest("Network/DeactivateMapping", mznlId, headerData);
}

/**
 * @description restore a zone-network mapping
 * @param {*mznlId of the network row (not network id)} mznlId
 * @returns
 */
async function ReactivateMapping(mznlId, headerData) {
  return await statusChangeRequest("Network/ReactivateMapping", mznlId, headerData);
}

export default networkConfigServices;
